module.exports = __webpack_public_path__ + "img/patients_sign-up_1.daff4e40.png";